import WhatIs from "./WhatIs";

export default WhatIs;